import React, { Component } from 'react';

import Header from '../../../Common/Component/Header';
import Sidebar from '../../../Common/Component/Sidebar';
import Aside from '../Component/Common/Aside';

import Step1 from '../Component/Step1';
import Step2 from '../Component/Step2';
// import Step3 from '../Component/Step3';
import moment from 'moment-timezone';
import { map, union, spread } from 'lodash';
import { message } from 'antd';


class WeekSetup extends Component {
  state = {
    current: 0,
    week_start_date: moment().startOf('week').format('YYYY-MM-DD'),
    is_week_setup: false,
    serach_value: "",
    residentail_value: "",
    technician_details: [],
    service_type_value: [],
    is_rerun_optimization: false,
    selected_resource : [],
    selected_franchise : ''
  }

  componentDidMount() {
    const user = JSON.parse(localStorage.getItem("authUser"))
      ? JSON.parse(localStorage.getItem("authUser"))
      : "";
    this.setState({
      selected_franchise: user?.user?.associated_field_offices[0].uuid
    })
  }
  UNSAFE_componentWillReceiveProps = (props) => {
    if(props && props.WeeklySetup && props.WeeklySetup.data && props.WeeklySetup.data.message){
      message.success('Services have been sent for scheduling and optimization.', 10);
      setTimeout(()=> {
        this.nextStep(0);
        this.props.resetWeeklyAllocation()
      },2000)
    }
  }

  handleWeekDate = (start) => {
    this.setState({
      week_start_date: start,
    })
  }

  handleCompeleteWeekSetup = (value) => {
    this.setState({
      is_week_setup: value
    })
  }

  //Get Technician Details
  handleTechnicianDetails = (data) => {
    this.setState({ technician_details: data });
  }

  // handle service checked types
  handleServicesTypes = (value) => {
    this.setState({
      service_type_value: value,
    })
  }

  //Handle Selected Technician
  handleSelectedTechnician = (value) => {
    // this.setState({
    //   selected_resource: value
    // })
    // this.state.selected_resource.push(value);
    // this.setState({
    //   selected_resource : [...this.state.selected_resource,value]
    // })
    this.setState({
      selected_resource : value
    })
  }

  //Handle Selected Franchise
  handleSelectedFranchise = (value) => {
    this.setState({
      selected_franchise : value
    })
  }

  RenderAllStep = () => {
    let { current } = this.state;

    switch (current) {
    case 0:
      return <Step1
        {...this.props}
        nextStep={(e) => { this.nextStep(e) }}
        weekStartDate={this.state.week_start_date}
        handleTechnicianDetails={(e) => this.handleTechnicianDetails(e)}
        selected_franchise={this.state.selected_franchise}
        current={this.state.current}
        isWeekSetup={this.state.is_week_setup}
        handelRerunOptimization={(e) => this.handelRerunOptimization(e)}
        isRerunOptimization={this.state.is_rerun_optimization}
        previousStep={this.previousStep}
        handleCompeleteWeekSetup={(e) => this.handleCompeleteWeekSetup(e)}
      />
    case 1:
      return <Step2 
        {...this.props} 
        weekStartDate={this.state.week_start_date}
        selected_franchise={this.state.selected_franchise}
        nextStep={(e) => { this.nextStep(e) }}
        current={this.state.current}
        isWeekSetup={this.state.is_week_setup}
        handelRerunOptimization={(e) => this.handelRerunOptimization(e)}
        isRerunOptimization={this.state.is_rerun_optimization}
        previousStep={this.previousStep}
        handleCompeleteWeekSetup={(e) => this.handleCompeleteWeekSetup(e)}
      />
      // case 2:
      // return <Step3 {...this.props} previousStep={this.previousStep} />

      // return <Step3 {...this.props}
      //   previousStep={this.previousStep}
      //   weekStartDate={this.state.week_start_date}
      //   isWeekSetup={this.state.is_week_setup}
      //   searchValue={this.state.serach_value}
      //   residentail_value={this.state.residentail_value}
      //   service_type_value={this.state.service_type_value}
      //   technician_details={this.state.technician_details}
      //   isRerunOptimization={this.state.is_rerun_optimization}
      //   handelRerunOptimization={(e) => this.handelRerunOptimization(e)}
      //   selected_resource={this.state.selected_resource}
      //   selected_franchise={this.state.selected_franchise}
      // />
    default:
      return <Step1 
        {...this.props} 
        weekStartDate={this.state.week_start_date}
        selected_franchise={this.state.selected_franchise}
        nextStep={(e) => { this.nextStep(e) }}
      />
    }
  }

  //Next Step
  nextStep = (e) => {
    if(e === 2){
      this.getWeekAllocation();
    }
    else {
      this.setState({
        current: e
      })
    }
  }


   //Get All Week Allocation
   getWeekAllocation = async () => {
     this.setState({
       loader: true
     });
     let tem_keys = [];
     let residentail_selected_row_keys = JSON.parse(sessionStorage.getItem('residential_selected_row_keys')) || '';
     let intial_selected_row_keys = JSON.parse(sessionStorage.getItem('intial_selected_row_keys')) || '';
     let commercial_selected_row_keys = JSON.parse(sessionStorage.getItem('commercial_selected_row_keys')) || '';
     // let install_selected_row_keys = JSON.parse(sessionStorage.getItem('install_selected_row_keys')) || '';

     const fn = spread(union);
     const arrs = [residentail_selected_row_keys, intial_selected_row_keys, commercial_selected_row_keys];
     tem_keys = fn(arrs);
     let data = {
       service_uuid_list: tem_keys,
       allocation_start_date: moment(this.props.weekStartDate).format('YYYY-MM-DD'),
       field_office__uuid: this.props.selected_franchise
     }
     this.setState({ afterMoveWeekAllocation: false });
     await this.props.getWeeklyAllocation(data);
   }

  //Previous Step
  previousStep = (e) => {
    if (e === 1) {
      this.setState({ is_week_setup: false })
    }
    this.setState({
      current: e
    })
  }

  // handle serach value
  handleSearchValue = (value) => {
    this.setState({
      serach_value: value
    })
  }

  residentailServices = (value) => {
    this.setState({
      residentail_value: value
    })
  }

  handelRerunOptimization = (value) => {
    this.setState({
      is_rerun_optimization: value
    })
  }
  render() {
    return (
      <div id="wrapper">
        <div className="content-area">
          {/* Header */}
          <Header placeholder={'Search acc number, customer address or contact details'} disabled={true} />

          {/* Sidebar */}
          <Sidebar history={this.props.history} />
          <div className="container">
            <div className="aside-area pt-0 account_module_wrapper">
              <Aside
                {...this.props}
                handleWeekDate={(e) => this.handleWeekDate(e)}
                handleCompeleteWeekSetup={(e) => this.handleCompeleteWeekSetup(e)}
                handleSearchValue={(e) => this.handleSearchValue(e)}
                residentailServices={(e) => this.residentailServices(e)}
                isWeekSetup={this.state.is_week_setup}
                nextStep={(e) => { this.nextStep(e) }}
                previousStep={(e) => { this.previousStep(e) }}
                current={this.state.current}
                handleServicesTypes={(event) => this.handleServicesTypes(event)}
                handelRerunOptimization={(e) => this.handelRerunOptimization(e)}
                isRerunOptimization={this.state.is_rerun_optimization}
                technician_details={this.state.technician_details}
                handleSelectedTechnician={(e) => this.handleSelectedTechnician(e)}
                handleSelectedFranchise={(e) => this.handleSelectedFranchise(e)}
                selected_franchise={this.state.selected_franchise}
                selected_resource={this.state.selected_resource}
              />

              {this.RenderAllStep()}
              {/* <div className="d-flex justify-content-end w-100">
                 <button className="btn btn-primary">Next Step</button>
              </div> */}

            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default WeekSetup;